import React, {FC, HTMLAttributes, useId} from "react"
import styled from "styled-components"
import Item from "./Item";

interface CheckBoxProps extends HTMLAttributes<HTMLInputElement> {
    label: string
    checked?: boolean
    name?: string
}

const CheckboxLabel = styled.label`
    background: #3B5049;
    color: #fff;
    padding: 20px;
    border-radius: 15px; 
    text-align: center;
    text-transform: uppercase;
    font-size: 1rem;
    transition: all .3s;
    cursor: pointer;
    display: flex;
    flex: calc(100% - 35px);
    @media screen and (min-width: 600px) {
        flex: calc(50% - 35px);
        padding: 40px;
    }
    @media screen and (min-width: 900px) {
        flex: calc(33.33% - 35px);
        padding: 70px;
    }
    width: 0;
    align-content: center;
    justify-content: center;
    align-items: center;
    user-select: none;
`;

const CheckboxInput = styled.input.attrs({ type: 'checkbox' })`
  display: none;
  &:checked + ${CheckboxLabel} {
    background: #ADC2A3;
    color: #fff;
  }
`;

const CheckboxButton: FC<CheckBoxProps> = ({ name, checked, label, id, ...otherProps }) => {

    const customId = useId()

    return (
            <>
                <CheckboxInput name={name} id={id || customId} checked={checked} {...otherProps} />
                {label && <CheckboxLabel className={"survey-checkbox-button"} dangerouslySetInnerHTML={{__html: label}} htmlFor={id || customId} />}
            </>
    )
}

export default CheckboxButton;
